import React from 'react'
import Navbar from '../../components/navbar_poc'
import { Link } from 'react-router-dom'
import { useParams } from 'react-router-dom';
import bg1 from '../../assets/images/single_case.jpg'
import client from '../../assets/images/client/05.jpg'
import Shape from '../../components/shape'
import ShapeTwo from '../../components/shape-two'
import Footer from '../../components/footer'
import { casesData } from '../../data'
export default function PageCaseSingle() {
    const { id } = useParams();
    const study = casesData[id];
  return (
    <>
    <Navbar navLight={true}/> 

    <section className="bg-half-170 bg-light d-table w-100" style={{backgroundImage:`url(${bg1})`, backgroundPosition:'center'}}>
      <div className="container">
          <div className="row position-relative align-items-center pt-4">
              <div className="col-lg-6">
                  <div className="title-heading p-4 rounded bg-white shadow mt-4">
                      <span className="badge bg-primary rounded-pill"> Casestudy </span>
                      <h2 className="mt-3">{study.title}</h2>
                      <p className="para-desc text-muted">Start work with <span className="text-primary">Leaping</span>. Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                      <div className="mt-4">
                          <div className="d-flex">
                              <img src={client} className="img-fluid avatar avatar-small rounded-pill me-3 shadow" alt=""/>
                              <div className="author mt-3">
                                  <h5 className="mb-0"><Link to="#" className="text-dark name">{study.name}</Link></h5>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </section>
    <ShapeTwo/>

    <section className="section">
      <div className="container">
          <div className="row">
              <div className="col-12">
                  <div className="casestudy">
                       <h4 className="mt-4"> Background</h4>
                      <p className="text-muted">{study.background}</p>
                  
                      <h4 className="mt-4">Challenge :</h4>
                      <p className="text-muted description">{study.challenge}</p>                            

                      <h4 className="mt-4">Solution :</h4>
                      <p className="text-muted description">{study.solution}</p>

                      <h4 className="mt-4">Results :</h4>
                      <p className="text-muted description">{study.result}</p>
                  </div>
              </div>
          </div>
      </div>
    </section>
    <Shape/>
    <Footer/>
    </>
  )
}
